module.exports = __webpack_public_path__ + "static/media/corporate-services-img47.042a3505.jpg";